﻿<div class="card card-default rdo-card invisible" [class.active]="selected" [class.rdo-card-default]="!selected" [class.rdo-card-highlight]="selected"
  title="{{(cardData[titleSelector] || defaultTitle) | translate}} " [class.invisible]="hidden" (click)="select()">

  <div class="card-header">
    <div class="card-title">
      <i class="icon-left fa" [ngClass]="icon"></i>{{(cardData[titleSelector] || defaultTitle) | translate}}
    </div>
  </div>
  <div class="card-body">
    <div class="rdo-card-panel-content">
      <div>
        @if (isBenchmarkMode()) {
          <div class="card-title" id="{{'sales_reps.compared_revenue.' + baseId | rdoPathToId}}">
            {{'main.tabs.sales_reps.compared_revenue' | translate}}
          </div>
          <div class="rdo-card-metric">
            {{cardData.RevenueBenchmarked | rdoCurrency:true:translateService.currentLang}} / <span [ngClass]="{'text-danger' : cardData.RevenueBenchmarkedDifference < 0}">
            {{cardData.RevenueBenchmarkedDifference | rdoCurrency:true:translateService.currentLang}}
          </span>
        </div>
      }
      @if (!isBenchmarkMode()) {
        <div class="card-title" id="{{'sales_reps.total_revenue.' + baseId | rdoPathToId}}">
          {{'main.tabs.sales_reps.total_revenue' | translate}}
        </div>
        <div class="rdo-card-metric">
          {{cardData.RevenueTotal | rdoCurrency:true:translateService.currentLang}} / <span [ngClass]="{'text-danger' : cardData.RevenueBookDifference < 0}">
          {{cardData.RevenueBookDifference | rdoCurrency:true:translateService.currentLang}}
        </span>
      </div>
    }
  </div>
  <div class="rdo-card-right-group">
    <div class="card-title" id="{{'sales_reps.book_discount.' + baseId | rdoPathToId}}">
      {{'main.tabs.sales_reps.book_discount' | translate}}
    </div>
    <div class="rdo-card-metric">
      <i class="fa fa-book"></i>&nbsp; <span [ngClass]="{'text-danger':getBookDiscount(cardData)  < 0}">{{ getBookDiscount(cardData) | percent:'1.1-1'}}</span>
    </div>
  </div>
</div>
</div>
</div>
